import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationData {
  type: string;
  message: string;
}

interface NotificationState {
  type: string | false;
  message: string | false;
}

const initialState: NotificationState = {
  type: false,
  message: false,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<NotificationData>) => {
      state.type = action.payload.type.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
      state.message = action.payload.message;
    },

    clearNotification: (state) => {
      state.type = false;
      state.message = false;
    },
  },
});

export const {
  setNotification,
  clearNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;